module.exports = __webpack_public_path__ + "static/media/download.1cfafcb3.svg";